import { Component, OnInit, Inject } from '@angular/core';
import { MatDatepickerInputEvent, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { HttpService } from '../../../services/http/http.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-user-list-filter',
  templateUrl: './user-list-filter.component.html',
  styleUrls: ['./user-list-filter.component.scss']
})
export class UserListFilterComponent implements OnInit {
  userStage = [];
  startDate1;
  startDate;
  endDate; endDate1;
  permanentPincode: string;
  currentPincode: string;
  campaignName;
  campaignType;
  source;
  date = new Date();
  minDate = moment(this.date).add(1, 'd').toDate();
  maxDate = moment(this.date).add(60, 'd').toDate();
  date1 = new Date();
  sourceArray = []
  campaignTypeArray = ['REGISTER_ONLY', 'MCQ_TEST', 'REFERRAL']
  campaignArray = [];
  userStageArray = ['Started', 'Not Started', 'Passed', 'Failed', 'Joined', 'Not Joined'];
  keyList = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
  startDatePicker = new FormControl('');
  endDatePicker = new FormControl('');
  campaignList = [];
  uniqueArraySource = [];
  filterParams;
  constructor(public dialogRef: MatDialogRef<UserListFilterComponent>,
    private httpService: HttpService,
    private spinnerService: Ng4LoadingSpinnerService,
    private snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.filterParams = data;
    console.log("Filter Params: ", this.filterParams);
  }

  ngOnInit() {
    this.getCampaignList();
    this.campaignName = this.filterParams.camp_name;
    this.campaignType = this.filterParams.camp_type;
    this.source = this.filterParams.camp_source;
    this.currentPincode = this.filterParams.currentPinCode;
    this.permanentPincode = this.filterParams.permanentPinCode;
    this.startDatePicker.setValue(moment(this.filterParams.strt_date, 'YYYY/MM/DD').toDate());
    this.endDatePicker.setValue(moment(this.filterParams.end_date, 'YYYY/MM/DD').toDate());
  }

  closeDialog(data): void {
    this.dialogRef.close(data);

  }
  addEvent(event: MatDatepickerInputEvent<Date>) {
    var date = this.convertDate(event.value);
    this.startDate = date;
  }
  addEvent1(event: MatDatepickerInputEvent<Date>) {
    var date = this.convertDate(event.value);
    this.endDate = date;
  }

  getMinDate(): Date {
    return moment(this.startDate, "YYYY-MM-DD").add(1, 'd').toDate();
  }
  convertDate(dateToConvert) {
    var dateObj = new Date(dateToConvert);
    var month = dateObj.getMonth() + 1;
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    let date = year + '-' + month + '-' + day;
    return date;
  }

  equals(objOne, objTwo) {
    if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
      return objOne.id === objTwo.id;
    }
  }

  clearAll() {
    this.userStage = [];
    this.currentPincode = '';
    this.permanentPincode = '',
      this.campaignName = '';
    this.source = '',
      this.startDatePicker.setValue(null),
      this.endDatePicker.setValue(null),
      this.campaignType = '';
  }

  applyFilter(): void {
    var data = {
      usr_stage: this.userStage,
      strt_date: this.startDate,
      end_date: this.endDate,
      currentPinCode: this.currentPincode,
      permanentPinCode: this.permanentPincode,
      camp_name: this.campaignName,
      camp_type: this.campaignType,
      camp_source: this.source
    }
    console.log("filter Data", data);
    this.closeDialog(data);
  }

  getCampaignList() {
    this.spinnerService.show();
    var contentBody = { url: "/campaigns" }
    this.httpService.httpGet(contentBody).subscribe(response => {
      this.campaignList = response;
      console.log("dasdfgahjdkl", this.campaignList);
      this.spinnerService.hide();
      this.createUniqueArray();


    }, error => {
      console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message)
    })
  }
  createUniqueArray() {
    for (let i = 0; i < this.campaignList.length; i++) {
      this.sourceArray.push(this.campaignList[i].source);
      this.campaignArray.push(this.campaignList[i].name)
    }
    this.uniqueArraySource = Array.from(new Set(this.sourceArray));
    console.log("uniqueArray", this.uniqueArraySource);
  }

  textToString(event) {
    let isNumber = false;

    for (let i = 0; i < this.keyList.length; i++) {
      if (this.keyList[i] === event.key) {
        isNumber = true;
        break;
      }
    }

    if (!isNumber) {
      this.currentPincode = this.currentPincode.substr(0, this.currentPincode.length - 1);
    }
  }

  textToString1(event) {
    let isNumber = false;

    for (let i = 0; i < this.keyList.length; i++) {
      if (this.keyList[i] === event.key) {
        isNumber = true;
        break;
      }
    }

    if (!isNumber) {
      this.permanentPincode = this.permanentPincode.substr(0, this.permanentPincode.length - 1);
    }
  }

  openSnackBar(message: string) {
    if (message) {
      this.snackbar.open(message, null, {
        duration: 2000,
      });
    }
    else {
      this.snackbar.open('Network Error', null, {
        duration: 2000,
      });
    }
  }
}
